import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryKeys } from './query-keys';

export function useUsageStatus() {
  return useQuery({
    queryKey: queryKeys.usage.current(),
    queryFn: () => api.checkUsageLimit(),
    staleTime: 1000 * 60, // 1 minute
    refetchInterval: 1000 * 60 * 5, // Refetch every 5 minutes
  });
}
